module.exports = __webpack_public_path__ + "static/media/login-banner.412c68da.png";